// @ actions
const signaturePatternActions = require('actions/signaturePattern');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP
} = require('constants/index');
const { API_CHANNEL } = require('constants/contactCenter/cardTransferMoneyToCheckingAccount');

//@utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { formatAmountForService } = require('utilities/currencyHelper');

const requestCardTransferMoneyToCheckingAccountStart = () => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_REQUEST_START,
});

const requestCardTransferMoneyToCheckingAccountSuccess = response => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_REQUEST_SUCCESS,
    payload: Object.assign({}, response)
});

const requestCardTransferMoneyToCheckingAccountError = error => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_REQUEST_FAILURE,
    payload: {
        error
    }
});

const requestCardTransferMoneyToCheckingAccount = cardId => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);

    const params = {
        query: {
            'canal': API_CHANNEL,
            'centro': API_CENTER,
            'codigodepersona': immCard.getIn(['person', 'personCode']),
            'empresa': API_ENTERPRISE_NUMBER,
            'numeroTarjetaPin': immCard.get('number'),
            'numerodecontrato': immCard.getIn(['contract', 'number']),
            'producto': immCard.getIn(['contract', 'product']),
            'tipodepersona': immCard.getIn(['person', 'personType']),
        }
    };

    dispatch(requestCardTransferMoneyToCheckingAccountStart());

    return APIPost({ dispatch, endpoint: 'cardTransferMoneyToCheckingAccountRequest', params })
        .then(response => {
            dispatch(requestCardTransferMoneyToCheckingAccountSuccess(response));
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(requestCardTransferMoneyToCheckingAccountError(response.error));
            } else {
                throw response;
            }
        });
};

const setAmount = amount => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_SET_AMOUNT,
    payload: {
        amount
    }
});

const validateStep = step => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_VALIDATE_STEP,
    payload: {
        step
    }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const postTransferMoneyToCheckingAccountStart = () => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_SAVE_START,
});

const postTransferMoneyToCheckingAccountSuccess = response => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_SAVE_SUCCESS,
    payload: Object.assign({}, response)
});

const postTransferMoneyToCheckingAccountError = error => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_SAVE_FAILURE,
    payload: {
        error
    }
});

const postTransferMoneyToCheckingAccount = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.get('byId').get(cardId);
        const immCardTransferMoneyToCheckingAccount = getState().cardTransferMoneyToCheckingAccount;

        const params = {
            query:  {
                'canal': API_CHANNEL,
                'cliente': {
                    'codigodepersona': immCard.getIn(['person', 'personCode']),
                    'tipodepersona': immCard.getIn(['person', 'personType']),
                },
                'coestrefcodigoEstadoReferencia': immCardTransferMoneyToCheckingAccount.getIn(['response', 'coestrefcodigoEstadoReferencia']),
                'contratoTarjeta': {
                    'centro': {
                        'centro': API_CENTER,
                        'empresa': API_ENTERPRISE_NUMBER,
                    },
                    'numerodecontrato': immCard.getIn(['contract', 'number']),
                    'producto': immCard.getIn(['contract', 'product']),
                },
                'cuentaIngresoAsoContrato': {
                    'codbban': immCardTransferMoneyToCheckingAccount.getIn(['response', 'cuentaIngresoAsoContrato', 'codbban']),
                    'digitodecontrol': immCardTransferMoneyToCheckingAccount.getIn(['response', 'cuentaIngresoAsoContrato', 'digitodecontrol']),
                    'pais': immCardTransferMoneyToCheckingAccount.getIn(['response', 'cuentaIngresoAsoContrato', 'pais']),
                },
                'idsubtipcodSudtipoProductoContrato': immCardTransferMoneyToCheckingAccount.getIn(['response', 'idsubtipcodSudtipoProductoContrato']),
                'jimppdtesaldoDipantesyDespTrasp': {
                    'divisa': immCardTransferMoneyToCheckingAccount.getIn(['response', 'jimppdtesaldoDipantesyDespTrasp', 'currency']),
                    'importe': immCardTransferMoneyToCheckingAccount.getIn(['response', 'jimppdtesaldoDipantesyDespTrasp', 'amount']),
                },
                'jmodalidmodalidadFormaPago': immCardTransferMoneyToCheckingAccount.getIn(['response', 'jmodalidmodalidadFormaPago']),
                'jreclpagimporteTraspaso': {
                    'divisa': immCardTransferMoneyToCheckingAccount.getIn(['steps', FIRST_STEP, 'currency']),
                    'importe': formatAmountForService(immCardTransferMoneyToCheckingAccount.getIn(['steps', FIRST_STEP, 'amount']), true),
                },
                'jtipoliqtipoLiquidacion': immCardTransferMoneyToCheckingAccount.getIn(['response', 'jtipoliqtipoLiquidacion']),
                'mlforpagcodigoFormaPago': immCardTransferMoneyToCheckingAccount.getIn(['response', 'mlforpagcodigoFormaPago']),
                'nomsprodtipoTarjeta': immCardTransferMoneyToCheckingAccount.getIn(['response', 'nomsprodtipoTarjeta']),
                'numbenefnumeroBeneficiario': immCardTransferMoneyToCheckingAccount.getIn(['response', 'numbenefnumeroBeneficiario']),
                'nutarbennumeroSecuencialTarjeta': immCardTransferMoneyToCheckingAccount.getIn(['response', 'nutarbennumeroSecuencialTarjeta']),
                'panmdpnumeroTarjeta': immCard.get('number'),
                dataToken,
            }
        };

        dispatch(postTransferMoneyToCheckingAccountStart());
        APIPost({ dispatch, endpoint: 'cardTransferMoneyToCheckingAccountConfirmation', params })
            .then(response => dispatch(postTransferMoneyToCheckingAccountSuccess(response)))
            .catch(response => dispatch(postTransferMoneyToCheckingAccountError(response.error)));
    };

    return new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const clearRequest = () => ({
    type: actionTypes.CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT_CLEAR
});

module.exports = {
    requestCardTransferMoneyToCheckingAccount,
    setAmount,
    validateStep,
    setVisibleStep,
    postTransferMoneyToCheckingAccount,
    clearRequest,
}
